var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"favorite",on:{"click":_vm.addToFavorites}},[_c('div',{staticClass:"favorite__wrapper"},[(_vm.ready)?_c('Row',[_c('Icon',{staticClass:"favorite__icon",attrs:{"xlink":_vm.params.favorited ? 'bookmark-filled' : 'bookmark',"viewport":"0 0 30 30"}}),_vm._t("default")],2):_c('Loader',{attrs:{"params":{style: _vm.style}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }